import { SET_FILTERS, RESET_FILTERS } from './actionTypes';

export const setFilters = filters => {
  return { type: SET_FILTERS, filters };
};

export const resetFilters = () => {
  return { type: RESET_FILTERS };
};
